import WfMonitor from '@webfunny/monitor'
import { envConfig } from './config/env.js'

// 初始化上报信息，越早执行越好
WfMonitor.initMonitor({
  webfunnyDomain: envConfig.webfunnyDomain,
  webfunnyAssetsDomain: envConfig.webfunnyAssetsDomain,
  webfunnyMonitorId: envConfig.webfunnyMonitorId,
  env: envConfig.env,
  projectVersion: envConfig.projectVersion,
  hasTrace: envConfig.hasTrace,
  startList: ['pageView', 'jsError', 'httpLog', 'resource', 'behavior']
})
